export const en = {
  footer: {
    description: "A short description about the product and its mission.",
    resources: "Resources",
    support: "Support",
    legal: "Legal",
    validation: "Seal Validation",
    history: "Consultation History",
    reports: "Reports & Statistics",
    geolocation: "Geolocation",
    complaint: "Report Irregularities",
    helpCenter: "Help Center",
    tutorials: "Tutorials",
    contact: "Contact",
    faq: "FAQ",
    reportProblem: "Report a Problem",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    licenses: "Licenses",
    portal: "Portal",
    copyright: "All rights reserved.",
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      youtube: "YouTube",
    },
  },
  nav: {
    validateSeal: "Validate Seal",
    howItWorks: "How It Works",
    faq: "Frequently Asked Questions (FAQ)",
    reportProblem: "Report a Problem",
    contact: "Contact",
    menu: "Menu",
    benefits: "Benefits",
    resources: "Resources",
    queryHistory: "Consultation History",
  },
  querysFilter: {
    title: "Filters",
    description: "Refine your search using the filters below.",
    inputPlaceholder: "Search by ID",
    dateFilter: {
      all: "All dates",
      today: "Today",
      lastSevenDays: "Last 7 days",
      lastThirtyDays: "Last 30 days",
    },
  },

  contactPage: {
    title: "Contact Us",
    subtitle: "Send your message to our team",
    emailInputLabel: "Email",
    phoneInputLabel: "Phone (optional)",
    messageInputLabel: "Message",
    messageInputPlaceholder: "Write your message here...",
    submitButtonText: "Send Message",
    whatsAppButton: "Contact us on WhatsApp",
  },
  faqPage: {
    title: "Frequently Asked Questions",
    subtitle: "Find answers to the most common questions",
    items: [
      {
        question: "What are the seals and how do they work?",
        answer:
          "Seals are authenticity labels applied to each product. Each seal has a unique and sequential number (e.g., 1, 2, 3... up to 1000), allowing individual tracking of each produced product. This ensures authenticity and full production control.",
      },
      {
        question: "Can seals be individually tracked?",
        answer:
          "Yes! Each seal has a unique number that allows individual tracking. You can view the history of any seal, including when it was created, when it was used, and which product it was applied to.",
      },
    ],
  },

  denouncePage: {
    title: "Report Counterfeit Seal",
    subtitle: "Help us fight counterfeiting by reporting suspicious seals",
    imagesRequired: "Please add at least one image.",
    submittingText: "Submitting...",

    imagesSectionTitle: "Images",

    imagesUploadLabel: "Click or drag images here",
    imagesUploadHint: "PNG, JPG, WEBP up to 10MB each",

    reporterSectionTitle: "Reporter Information",
    sealSectionTitle: "Seal Information",
    detailsSectionTitle: "Report Details",

    nameLabel: "Full name",
    namePlaceholder: "Your name",

    emailLabel: "Email",
    emailPlaceholder: "your@email.com",

    phoneLabel: "Phone (optional)",
    phonePlaceholder: "(00) 00000-0000",

    sealCodeLabel: "Seal Code",
    sealCodePlaceholder: "e.g. SEAL-2024-XXXX",

    sealTypeLabel: "Seal Type",
    sealTypePlaceholder: "Select the type",
    sealTypeOptions: {
      holographic: "Holographic",
      other: "Other",
    },

    brandLabel: "Brand / Manufacturer",
    brandPlaceholder: "Brand name",

    productLabel: "Product Name",
    productPlaceholder: "Product name",

    locationLabel: "Place of Purchase / Discovery",
    locationPlaceholder: "Store, city, or website link",

    reasonLabel: "Reason for Report",
    reasonPlaceholder: "Select a reason",
    reasonOptions: {
      fakeSeal: "Visibly fake seal",
      invalidCode: "Invalid code during validation",
      duplicate: "Duplicate / already used code",
      damaged: "Tampered or damaged seal",
      suspicious: "Product suspected of being counterfeit",
      other: "Other reason",
    },

    descriptionLabel: "Detailed description",
    descriptionPlaceholder:
      "Describe in detail what irregularities you observed on the seal or product...",

    submitButtonText: "Submit Report",
  },

  common: {
    loadingConsultation: "Performing a query for this text now",
    cancel: "Cancel",
    confirm: "Confirm",
    back: "Back",
    retry: "Retry",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    yes: "Yes",
    no: "No",
    close: "Close",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    send: "Send",
    next: "Next",
    previous: "Previous",
    validations: "Validations",
    validating: "Validating...",
    photo: "Photo",
    qrCode: "QR Code",
    list: "List",
    map: "Map",
    seal: "Seal",
    code: "Code",
    loadImages: "Load image",
  },
  camera: {
    instructions: {
      title: "Prepare the seal",
      description:
        "Point the camera at the seal and wait. The system will recognize the seal and take the photo automatically.",
      focusDesc: "Hold your phone steady while the system takes the photo.",
      button: "Start",
    },
    scanning: "Scanning...",
    positionQRHere: "Position QR code here",
    scanningAutomatically: "Scanning automatically",
    takePhoto: "Take photo",
    selectFile: "Select image",
    retake: "Retake",
    switchCamera: "Switch camera",
    positionSealHere: "Align the seal here",
    tapScreen: "Tap the screen to focus",
    tapToTakePhoto: "Tap the screen to take the photo",
    guidanceDetected: "Hold your phone still and wait.",
    guidancePreparing: "Preparing the camera...",
    guidanceFind: "Point the camera at the seal.",
    guidanceCloser: "Move the camera closer to the seal.",
    guidanceFarther: "Move the camera a little farther away.",
    guidanceCenter: "Center the seal.",
    guidanceHold: "Perfect. Hold still.",
    guidanceCapturing: "Capturing the best photo...",
    waitingWhileCameraLoads: "Please wait while the camera loads...",
    error: "Camera error",
    permissionDenied: "Camera permission denied. Please allow camera access.",
    cameraNotFound:
      "No camera found. Make sure your device has an available camera.",
    accessError: "Error accessing the camera. Please try again.",
    loadingTimeout:
      "Camera is taking too long to load. Check your permissions.",
    capturedPhoto: "Captured Serial",
    orientation: {
      portraitRecommended: "Portrait mode recommended",
      landscapeRecommended: "Landscape mode recommended",
      rotateToPortrait:
        "Rotate your device to portrait mode for a better capture experience.",
      rotateToLandscape:
        "Rotate your device to landscape mode for a better capture experience.",
      continueAnyway: "Continue anyway",
    },
    errorValidatingSeal: "Error validating seal",
    errorSendingPhoto: "Error sending photo",
    errorValidatingSealDescription:
      "An error occurred while validating the seal. Please try again.",
    errorProcessingImage:
      "An error occurred while processing your image. Please try again.",
    aiValidationTitle: "AI is analyzing your seal",
    aiValidationDescription:
      "We are checking the photo and its security features. The result will appear automatically.",
    aiValidationPhoto: "Captured photo",
    aiValidationStatus: "Analysis in progress",
    aiValidationWait: "This may take a few moments.",
    qrCodeNotFound: "QR code not found",
    qrCodeNotFoundWithEntry:
      "The seal’s QR code could not be identified. Make sure the seal is visible, well lit, and centered in the photo.",
    qrCodeNotFoundGeneric:
      "A valid QR code could not be identified in the image. Make sure the QR code is visible, well lit, and centered in the photo.",
  },
  tutorial: {
    qrTutorial: {
      title: "Seal Authenticity Verification",
      description:
        "To continue, take a photo of the seal. Artificial intelligence will validate the security features.",
      button: "Click here to take the photo",
    },
    photoStep: {
      step1: "Use the same seal from the scanned QR Code;",
      step2: "Photograph only one seal;",
      step3: "Center the seal on the screen;",
      step4: "Do not move the phone while taking the photo;",
      step5:
        "Please wait while the Artificial Intelligence performs the validation;",
    },
    navigation: {
      previous: "Previous",
      next: "Next",
      readQr: "Read QR Code",
    },
    modal: {
      title: "Prepare your camera",
      description: "Now you are ready to scan the seal’s QR Code!",
      button: "Let’s scan!",
      autoRedirect: "Automatically redirecting in 5 seconds...",
    },
  },
  securityAlert: {
    title: "Security Alert",
    potentiallyFake: "Potentially fake seal!",
    description:
      "The unique code does not match the expected value, which may indicate a counterfeit seal.",
    question:
      "Do you want to continue and register this verification as invalid?",
    confirmIrregularity: "Confirm Irregularity",
  },
  errorDisplay: {
    geolocationRequired: "Geolocation Required",
    sealNotFound: "Seal not found",
    verificationError: "Verification error",
    geolocationInstructions: {
      title: "How to enable geolocation:",
      step1: "• Click the location icon in the address bar",
      step2: '• Select "Allow" for this site',
      step3: "• Reload the page after allowing",
    },
    tryAgain: "Try again",
    backToHome: "Back to home",
    noResults: "No results found",
    noValidations: "No validations found",
  },
  addressInfo: {
    title: "Address",
    street: "Street",
    number: "Number",
    neighborhood: "Neighborhood",
    city: "City",
    state: "State",
    zipCode: "ZIP Code",
  },
  clientInfo: {
    title: "Client Information",
    cnpj: "CNPJ",
    name: "Name",
    phone: "Phone",
    email: "Email",
  },
  hashVerification: {
    title: "Unique Code Verification",
    description:
      "Compare the unique code below with the one printed on the seal",
    howToVerify:
      "How to verify: Compare each character of the above code with the one printed on the seal.",
    doesNotMatch: "Does Not Match",
    matches: "Yes, Matches",
    processing: "Processing...",
    validating: "Validating...",
  },
  loading: {
    validatingSeal: "Validating seal...",
  },
  geoProtectRoute: {
    title: "Getting your location",
    description:
      "We need your location to verify the seals. This may take a few seconds.",
    loading: "Loading location...",
  },
  errorsDisplay: {
    geolocationRequired: "Geolocation Required",
    sealNotFound: "Seal not found",
    verificationError: "Verification error",
    howToEnableGeolocation: "How to enable geolocation:",
    step1: "Click the location icon in the address bar",
    step2: 'Select "Allow" for this site',
    step3: "Reload the page after allowing",
    retry: "Try again",
    backHome: "Back to home",
  },
  errorBoundary: {
    title: "An unexpected error occurred",
    description: "Something went wrong while loading this page.",
    reload: "Reload page",
  },
  qrCodePage: {
    sealModal: {
      alignSeal: "Align the seal within the indicated area",
      title: "Seal not identified",
      lightingTitle: "Lighting",
      lightingDesc: "Avoid shadows and reflections on the seal.",
      framingTitle: "Framing",
      framingDesc: "Center the seal within the frame.",
      focusTitle: "Focus",
      usedSealTitle: "Matching",
      usedSealDesc: "Use the same seal as the QR Code",
      focusDesc: "Focus the camera before taking the photo.",
      button: "Take a new photo",
    },
    centerSealAlert: "Center the seal in the marked area",
    hashDoesNotMatch:
      "The seal number does not match our database. Please check if you are using the same seal as the scanned QR Code.",
    seeAllSecurityItems: "View all security items",
    experienceAR: "Try Augmented Reality",
    info: "The number identified in the photo matches the database record.",
    clickSealToCheck: "Click the seal to check security features",
    uniqueCodeValidated: "Unique code successfully validated",
    uniqueCodeDoesNotMatch: "Unique code does not match",
    capColor: "Cap Color",
    hash: "Hash",
    product: "Product",
    productInfo: "Product Information",
    serial: "Serial:",
    serialNotFound: "Serial not found",
    importer: "Importer:",
    batch: "Batch:",
    uniqueCode: "Unique code:",
    validated: "✓ Validated",
    takePhoto: "Take a photo",
    securityItems: {
      config: {
        useArrows: "Use arrows or drag to navigate",
        goToItem: "Go to item",
        noSecurityItems: "No security items available at the moment.",
      },
    },
    verificationResult: "Verification Result",
    suspicious:
      "Check for visible signs of tampering or inconsistencies, and then contact the supplier or manufacturer responsible for the purchased product.",
    qrCodeVerification: "QR Code Verification",
    validQrCodeDescription:
      "This QR Code appears to be valid, however, analyze the security items with artificial intelligence to validate the seal's authenticity!",
    authenticityAnalysis: "INMETRO seal authenticity analysis",
    imageAnalyzed: "Analyzed Image",
    qrCodeValid: "Valid QR Code",
    elements: "elements",
    detectedElements: "Detected Elements",
    securityItemsTitle: "Security Items",
    explanation: "Explanation",
    dataComparison: "Data Comparison",
    dbSerial: "Database Serial",
    photoSerial: "Photo Serial",
    confidence: "Confidence",
    backButton: "Back",
  },
  reportModal: {
    title: "Report Irregularity",
    description:
      "Provide where you found this suspicious seal and attach a photo",
    locationLabel: "Irregularity Location",
    locationPlaceholder: "Ex: ABC Pharmacy, 123 Flower Street",
    locationHint: "Be specific: establishment name, address, or landmark",
    photoLabel: "Irregular Seal Photo",
    photoHint: "The photo will help our team better identify the irregularity",
    takePhoto: "Take Photo",
    gallery: "Gallery",
    newPhoto: "New",
    positionSealHere: "Position the seal here",
    ensureReadable: "Make sure it is legible",
    sealReportedAsFake: "Seal reported as FAKE:",
    sealIdentifiedAsFake:
      "This seal was identified as potentially fake due to mismatch of the unique code.",
    reportSent: "Report Sent!",
    investigationMessage: "Our team will investigate the irregularity.",
    protocol: "Protocol:",
    errorSending: "Error Sending Report",
    tipsForBetterPhoto: "Tips for a better photo:",
    tips: {
      lighting: "• Make sure the seal is well lit",
      reflections: "• Avoid reflections and shadows",
      stability: "• Keep the camera steady",
      sealSize: "• The seal should occupy most of the photo",
      readability: "• Check if all codes are legible",
    },
    sending: "Sending...",
    report: "Report",
  },
  additionalInfo: {
    title: "Additional Information",
    description:
      "For more details about validation or to report problems, contact technical support via the Mistral website.",
  },
  validations: {
    title: "Validation Map",
    subtitle: "View all seal validations carried out in the system.",
    filters: {
      title: "Filters",
      description: "Search by address, serial number, or register",
      placeholder: "Search validations...",
      status: {
        valid: "Validated",
        invalid: "Rejected",
        pending: "Under review",
      },
      type: {
        title: "Validation type",
        qrcode: "QR Code",
        photo: "Photo",
      },
    },
    list: {
      title: "Validations",
      loading: "Loading validations...",
      empty: "No validations found",
      found: "validations found",
      view: {
        list: "List",
        map: "Map",
      },
    },
    details: {
      title: "Details",
      date: "Date",
      time: "Time",
      serialNumber: "Serial number",
      registerNumber: "Register number",
      address: "Full address",
      addressUnavailable: "Address not available",
      photo: {
        title: "Seal photo",
        none: "No photo available",
        capturedAt: "Captured on: {{date}} at {{time}}",
      },
      viewDetails: "View details",
      close: "Close details",
    },
    map: {
      error: {
        title: "Error loading map",
        description: "Check your internet connection or try again later.",
      },
      loadingMore: "Loading more validations...",
    },
  },
  internalDashboard: {
    header: {
      title: "Admin Dashboard",
      subtitle: "Inmetro Internal System",
      systemOnline: "System Online",
      signOut: "Sign Out",
    },
    welcome: {
      title: "Welcome to the Internal System",
      subtitle: "Choose one of the options below to continue",
    },
    cards: {
      mapAndQueries: {
        title: "Map and Queries",
        description:
          "Access the interactive map and perform seal validation queries",
        button: "Access Map",
      },
      history: {
        title: "History",
        description: "View full history of queries and validations performed",
        button: "View History",
      },
      userManagement: {
        title: "Internal Users",
        description:
          "Manage system internal users – create, edit, and remove access",
        button: "Manage Users",
      },
    },
  },
  loginPage: {
    title: "Sign in to your account",
    fields: {
      email: {
        label: "Email",
        placeholder: "Enter your email",
      },
      password: {
        label: "Password",
        placeholder: "Enter your password",
      },
    },
    links: {
      forgotPassword: "Forgot my password",
    },
    rememberMe: "Remember me",
    buttons: {
      signIn: "Sign In",
      signingIn: "Signing in...",
    },
    screenReader: {
      hidePassword: "Hide password",
      showPassword: "Show password",
    },
    errors: {
      emailRequired: "Email is required",
      emailInvalid: "Invalid email",
      cpfInvalid: "CPF must contain 11 digits",
      passwordRequired: "Password is required",
      passwordMinLength: "Password must be at least 6 characters",
      invalidCredentials: "Incorrect email or password",
      serverError: "Internal server error",
    },
    toasts: {
      loginError: "Login failed. Please check your credentials.",
      loginSuccess: "Login successful!",
      serverError: "Internal server error. Please try again.",
    },
  },
  queryPage: {
    title: "Entry Comparison",
    sections: {
      imageComparison: "Image Comparison",
      comparisonSummary: "Comparison Summary",
      detailedAnalysis: "Detailed Analysis",
    },
    sealOwner: {
      title: "Company details",
      description: "Information about the company responsible for the seal.",
      cnpj: "CNPJ",
      companyName: "Company name",
      productName: "Product name",
      notProvided: "Not provided",
    },
    sources: {
      database: "Expected Serial",
      photo: "Photo",
    },
    fields: {
      serialNumber: "Serial number",
      publicHash: "Public Hash",
    },
    status: {
      match: "Match",
      mismatch: "Mismatch",
      partial: "Partial",
      missing: "Not detected",
      discrepancyDetected: "Discrepancy detected",
      detected: "Detected",
    },
    messages: {
      noImage: "No image",
      notFound: "Not found",
      valueDiffers: "This value differs from the one in the database.",
    },
    buttons: {
      back: "Back",
      validateAnother: "Validate another seal",
    },
    emptyState: {
      title: "No records found",
      description: "There are no entries available for this query.",
      button: "Back",
    },
    notFound: {
      title: "Query not found",
      description: "Could not find data for this query.",
      button: "Back",
    },
    aiAnalysis: {
      title: "AI Analysis",
      badge: "AI-generated response",
      noAnalysis: "Unable to generate an analysis for these entries.",
      loading: {
        title: "Analyzing entries...",
        description:
          "Our AI is comparing the data and generating insights on the entries",
      },
      error: {
        title: "Analysis error",
        description: "Unable to generate analysis. Please try again later.",
        button: "Retry",
      },
      disclaimer:
        "This analysis is automatically generated and may not reflect all nuances of the data.",
    },
    dataComparisonCard: {
      title: "Serial Number Verification",
      database: "Database",
      found: "Found",
      photo: "Photo (OCR)",
      detected: "Detected",
      notDetected: "Not detected",
      notFound: "Not found",
      mismatchTitle: "Serial Number Mismatch",
      highConfidenceMessage:
        "The analysis indicates high confidence that the seal is authentic (confidence: {confidence}%), however the number detected in the photo does not match the number recorded in the database. This may indicate a legitimate seal applied incorrectly, possible tampering, or a photo taken from another seal.",
      lowConfidenceMessage:
        "The number detected in the photo does not match the number recorded in the database. In addition, the detection confidence is low ({confidence}%), which may indicate reading difficulty or problems with the seal.",
      partialMessage:
        "The serial number from the database was found, but it was not possible to read the number from the photo. This may happen if the image quality is low or the seal is damaged.",
    },
    explanationSection: {
      title: "How to interpret the results?",
      levels: {
        high: {
          range: "80% - 100%",
          trust: "High confidence",
          description: "The element was identified with confidence.",
        },
        medium: {
          range: "60% - 79%",
          trust: "Medium confidence",
          description:
            "There are indications of the element, but additional verification is recommended.",
        },
        low: {
          range: "0% - 59%",
          trust: "Low confidence",
          description: "The element was not confirmed in this capture.",
        },
      },
      footer:
        "Our artificial intelligence analyzes the image to detect INMETRO seal security elements. The percentage indicates the level of certainty that each element was correctly identified.",
    },
    verdictCard: {
      authentic: {
        title: "Authentic Seal",
        subtitle:
          "The seal's security items have been successfully authenticated!",
      },
      warning: {
        title: "Inconclusive Verification",
        subtitle: "Some elements require attention",
      },
      suspicious: {
        title: "Suspicious Seal",
        subtitle: "It was not possible to confirm authenticity",
      },
      aiBadge: "AI Analysis",
      overallConfidence: "Overall Confidence",
    },
  },
  notFoundPage: {
    title: "404",
    message: "Oops! The page you are looking for does not exist.",
    backText: "You can go back to the",
    homeLink: "home page",
  },
  reportPage: {
    header: {
      badge: "Seal Validation System",
      title: "Report Irregularities",
      subtitle:
        "Report counterfeit or irregular seals to help ensure safety and compliance.",
      anonymousTitle: "Anonymous Reports",
      anonymousSubtitle: "Your identity will be protected",
      backButton: "Back to Home Page",
    },
    howToReport: {
      title: "How to Report",
      subtitle: "Follow these steps to submit your report",
      steps: {
        step1: {
          title: "Fill out the form",
          description:
            "Provide as many details as possible about the irregularity found",
        },
        step2: {
          title: "Attach evidence",
          description:
            "Upload clear photos of the suspicious seal for analysis",
        },
        step3: {
          title: "Provide your details",
          description:
            "Your information is optional, but it helps with the investigation process",
        },
        step4: {
          title: "Track the process",
          description: "Receive updates on the progress of your report",
        },
      },
    },
    identifyingFakes: {
      title: "Identifying Fake Seals",
      subtitle: "Key features to check",
      characteristics: {
        holographic: {
          title: "Holographic elements",
          description:
            "Check if the seal has a watermark and holographic elements that change with the angle",
        },
        qrCode: {
          title: "Functional QR Code",
          description:
            "Verify if the QR code works and redirects to the official {{productName}} website",
        },
        printQuality: {
          title: "Print quality",
          description:
            "Look for printing errors, low graphic quality, or incorrect colors",
        },
        serialNumber: {
          title: "Valid serial number",
          description:
            "Confirm whether the serial number is valid in the official verification system",
        },
      },
      guideLink: "View full identification guide",
    },
    form: {
      title: "Report Form",
      subtitle:
        "Fill in the fields below with information about the irregularity found.",
      steps: {
        information: "Information",
        contact: "Contact",
        confirmation: "Confirmation",
        stepLabel: "Step {{current}} of {{total}}",
      },
      fields: {
        irregularityType: {
          label: "Type of Irregularity",
          placeholder: "Select the type of irregularity",
          options: {
            fake: "Counterfeit Seal",
            tampered: "Tampered Seal",
            reused: "Reused Seal",
            noSeal: "Product without Seal",
            other: "Other",
          },
        },
        description: {
          label: "Description of the Irregularity",
          placeholder: "Describe in detail the irregularity found",
          hint: "Include details such as seal features, identified issues, and other relevant information.",
        },
        location: {
          label: "Location",
          placeholder: "Where the seal was found",
        },
        date: {
          label: "Date of Occurrence",
        },
        image: {
          label: "Seal Image",
          uploadText: "Click to upload",
          tips: {
            title: "Tips for a good photo:",
            lighting: "Good lighting, no glare",
            centered: "Seal fully visible and centered",
            sharp: "Sharp image, no blur",
            format: "Formats: JPG, PNG (max. 5MB)",
          },
        },
        company: {
          label: "Company/Establishment (optional)",
          placeholder: "Name of the company or establishment",
          hint: "Provide the name of the establishment where the seal was found.",
        },
        contact: {
          label: "Contact Email",
          placeholder: "your@email.com",
          hint: "Your email will only be used for updates about this report and will not be shared.",
        },
        terms: {
          label:
            "I declare that the information provided is true and I am aware of the legal consequences of a false report.",
        },
      },
      alerts: {
        optionalData:
          "Your contact details are optional, but they help with the investigation process.",
        dataProtection: {
          title: "Data Protection",
          description:
            "Your personal data is protected in accordance with the LGPD and used only for the investigation process.",
        },
        falseReport: {
          title: "Warning",
          description:
            "False reports may result in legal liability. Make sure to provide accurate information.",
        },
      },
      summary: {
        title: "Report Summary",
        type: "Type:",
        location: "Location:",
        date: "Date:",
        contact: "Contact:",
        description: "Description:",
        attachedImage: "Attached Image:",
      },
      buttons: {
        back: "Back",
        continue: "Continue",
        submit: "Submit Report",
        submitting: "Submitting... {{progress}}%",
      },
    },
    success: {
      title: "Report Successfully Submitted",
      subtitle:
        "Your report has been registered and will be reviewed by our team.",
      protocol: "Protocol: #REP-{{number}}",
      message:
        "You will receive a confirmation email with the details of your report and will be able to track its status through your dashboard.",
      buttons: {
        dashboard: "Go to Dashboard",
        home: "Back to Home Page",
      },
      help: {
        text: "Need help?",
        link: "Contact support",
      },
    },
  },
  tutorialPage: {
    header: {
      skipTutorial: "Skip Tutorial",
      startCapture: "Start Capture",
      skipToCamera: "Skip to Camera",
    },
    steps: {
      step1: {
        title: "Correct Positioning",
        subtitle: "Place the seal inside the marked area on the camera screen.",
        tips: {
          title: "Tips:",
          center: "Center the seal in the marked area",
          parallel: "Keep the device parallel to the seal",
          avoid: "Avoid tilted angles that distort the image",
        },
      },
      step2: {
        title: "Proper Lighting",
        subtitle: "Ensure there is good lighting to capture all seal details.",
        examples: {
          good: "Good Example",
          bad: "Bad Example",
          goodLabel: "Good lighting",
          badLabel: "Insufficient lighting",
          correct: "Correct",
          incorrect: "Incorrect",
        },
        tips: {
          title: "Tips:",
          naturalLight:
            "Use well-lit environments, preferably with natural light",
          avoidShadows: "Avoid shadows over the seal",
          avoidReflections:
            "Avoid direct reflections that can hide important details",
        },
      },
      step3: {
        title: "Sharpness and Stability",
        subtitle:
          "Keep the device steady and ensure the image is sharp before capturing.",
        examples: {
          good: "Good Example",
          bad: "Bad Example",
          sharp: "Sharp",
          blurry: "Blurry",
        },
        tips: {
          title: "Tips:",
          steadyHands: "Keep your hands steady when taking the photo",
          waitFocus: "Wait for autofocus before capturing the image",
          fullSeal: "Try to capture the entire seal with all details",
          avoidMovement: "Avoid sudden movements during capture",
        },
      },
    },
    navigation: {
      previous: "Previous",
      next: "Next",
    },
    rotationModal: {
      title: "Rotate your phone",
      description:
        "For a better capture experience, we recommend using the camera in landscape orientation.",
      button: "Got it, let's go!",
      autoRedirect: "Automatically redirecting in 5 seconds...",
    },
    welcomeModal: {
      title: "Validation Tutorial",
      subtitle: "Learn how to take perfect photos for seal validation",
      available: {
        title: "Tutorial Available",
        description:
          "Would you like to see a short tutorial on how to take the best photo of the seal?",
      },
      bestResults: {
        title: "Best Results",
        description:
          "The tutorial helps ensure sharp photos and accurate validations",
      },
      buttons: {
        skip: "Skip Tutorial",
        start: "View Tutorial",
      },
    },
  },
  privacyPolicyPage: {
    title: "Privacy Policy",
    company: "PRIMI TECNOLOGIA LTDA",
    introP1:
      "PRIMI TECNOLOGIA LTDA PRIMI, headquartered at Estrada Rosa Scarpa, nº 65, Votuparim, Santana de Parnaíba, São Paulo – SP, ZIP Code 06513-010, in compliance with legal requirements and committed to providing excellent service to its prospects, visitors, clients, former clients, suppliers, service providers, former suppliers, former service providers, users, job applicants, employees and former employees (DATA SUBJECTS), hereby establishes its Privacy Policy.",
    introP2:
      "Through this Policy, PRIMI aims to comply with the legal requirements of Federal Law nº 13.709/2018 (Brazilian General Data Protection Law - LGPD), the Consumer Protection and Defense Code (Federal Law nº 8.078/1990) and the Brazilian Civil Rights Framework for the Internet (Federal Law nº 12.965/2014), as well as their updates and complementary regulations, ensuring that in all interaction and processing of DATA SUBJECTS' data there are solid and technical processes that consolidate Data and Information Security.",
    introP3:
      "Not only through its security certifications, PRIMI has a dedicated and trained team to protect all collected data and acts with the transparency of this policy to assure DATA SUBJECTS that their data is protected against leaks and violations, as well as using them strictly for the consented purposes.",
    introP4:
      "We collect and use some of our users' personal data, as controllers and operators of such personal data, being subject to all associated regulatory provisions.",
    introP5:
      "PRIMI is responsible for the Processing of DATA SUBJECTS' Personal Data and determines the purposes and means of processing through this policy available on our website, channels and platforms.",
    introP6:
      "Thus, by these terms, DATA SUBJECTS give full consent to the Processing of their Personal Data.",
    section1: {
      title: "I. COLLECTED DATA AND METHOD OF COLLECTION",
      p1: "The data collected by PRIMI, with the consent of DATA SUBJECTS, are Registration Data (Name, CPF, phone number, among others); Access Data (passwords, among others); Digital and Navigation Information (Cookies, among others); Financial Data (payment data, other information).",
      p2: "The collection of such data is carried out directly from DATA SUBJECTS through the platforms themselves or indirectly through third parties.",
      p3: "Regarding information and data provided by DATA SUBJECTS, direct collection takes place through PRIMI's digital platforms (Website, Primi Platform, Intelligent Seal, service centers, forms, chatbots, among others).",
      p4: "Regarding information and data obtained through third parties, PRIMI receives data and information through intermediary third parties, for example, on hiring platforms, government agencies, including credit information systems, among others.",
      p5: "Information and data may also be obtained automatically through the devices used by DATA SUBJECTS. This information is used to improve DATA SUBJECTS' experience on our platforms and utilities, such as cookies, tags, beacons for identity and session control, for example.",
      p6: "Additionally, data collection may occur on social media (LinkedIn, Instagram, Facebook) and government agencies (Inmetro, Transparency Portal, among others).",
    },
    section2: {
      title: "II. PROCESSING - STORAGE AND DATA PROTECTION",
      p1: "DATA SUBJECTS' data is protected and secured by the best technologies, techniques and internal processes to prevent leaks and violations.",
      p2: "PRIMI holds Security certifications such as ISO 27001 – Information Security and NBR 15540 – Graphic Security, and adopts physical and digital processes for data protection, as well as the best and most modern security practices in Information Technology.",
      p3: "PRIMI protects its data through restricted access to Personal Data, including electronic and physical access with password protection, data masking, anonymization, among other data protection techniques.",
      p4: "Furthermore, PRIMI adopts a strict Information Security Policy, which constantly has processes audited internally and externally; and these processes safeguard the integrity and confidentiality of processed data, especially because these processes guide and direct the actions of internal personnel and any third parties responsible for processing such data.",
      p5: "The storage period for personal data is as long as necessary for its use, depending on the respective legal storage obligation, PRIMI's needs and legitimate interest.",
    },
    section3: {
      title: "III. PURPOSE OF DATA COLLECTION",
      p1: "All data collected by PRIMI has several purposes, including but not limited to:",
      list: [
        {
          label: "For the production of our products:",
          text: "in the manufacturing of materials, PRIMI may use data received from clients and government agencies, being necessary requirements for security printing;",
        },
        {
          label:
            "For compliance with our legal obligations and regular exercise of rights:",
          text: "DATA SUBJECTS' data is used to fulfill legal obligations with government agencies and regulatory entities (ANPD, INMETRO, among others). Even after the termination of the relationship with PRIMI, data will remain under its control, considering that some personal data may be necessary for PRIMI to exercise its rights guaranteed by law, including as evidence in judicial, administrative or arbitration proceedings;",
        },
        {
          label: "For the use of our digital platforms and customer service:",
          text: "PRIMI may use DATA SUBJECTS' data to improve and personalize our platforms to their user profile through specific techniques;",
        },
        {
          label: "For Marketing actions and Communications with DATA SUBJECTS:",
          text: "PRIMI may use DATA SUBJECTS' data to prepare specific communications and marketing actions. Data processing is also necessary for interaction with our services;",
        },
        {
          label: "For fraud prevention and credit analysis:",
          text: "PRIMI may use DATA SUBJECTS' data for profile analysis within the scope of our activities;",
        },
        {
          label: "For PRIMI's legitimate interest:",
          text: "PRIMI may use DATA SUBJECTS' data for conducting statistical studies, creating metrics and indicators, for selection processes, hiring suppliers and service providers, product campaigns and/or offers.",
        },
      ],
    },
    section4: {
      title: "IV. SHARING OF PERSONAL DATA",
      p1: "PRIMI only shares personal data with third parties for legitimate interests and with public authorities to comply with legal obligations and under legal and judicial determination.",
      p2: "In such sharing of personal data, PRIMI has processes to ensure that the receiving party receives such data appropriately, guaranteeing the confidentiality of data transfer. PRIMI carries out data transfers that may be international, through secure processes with reliable suppliers.",
    },
    section5: {
      title: "V. RIGHTS AND DUTIES OF DATA SUBJECTS",
      p1: "At any time, DATA SUBJECTS have the right to know about the processing of their personal data; which personal data is processed; for what purpose it is processed; to request and correct incomplete, inaccurate or outdated data; to request anonymization, blocking or deletion of data they deem excessive; to request review of data concerning their interest; to request deletion of data processed with consent, except for compliance with legal obligation or other legitimate interest of PRIMI; to refuse consent - in this case, PRIMI will inform about the consequences of non-consent.",
      p2: "DATA SUBJECTS have the right to know how PRIMI processes their data, with a mandatory response within 15 days in complete format or immediately with a simplified response.",
      p3: "Processed DATA SUBJECTS' data may include information about the purpose of processing, data categories, storage periods, and entities with whom data has been shared. Additionally, DATA SUBJECTS may request data portability - except for data already anonymized.",
      p4: "PRIMI recommends that DATA SUBJECTS always maintain the confidentiality of their login and password, and never share their personal data and information with third parties. PRIMI cannot be held responsible for improper sharing of such data by DATA SUBJECTS themselves.",
      p5: "DATA SUBJECTS must always provide truthful information when using our products and services, subject to applicable legal sanctions.",
    },
    section6: {
      title: "VI. DATA PROTECTION OFFICER CONTACT",
      p1: "For any contact needs, exercising your rights and clarifying doubts with PRIMI, you may contact the Data Protection Officer directly, Ms. Victória Colombarolli Ferreira.",
      p2: "Contact:",
      email: "dpo@primi.com.br",
    },
    section7: {
      title: "VII. FINAL PROVISIONS",
      p1: "Finally, PRIMI reserves the right to modify this policy and privacy notice at any time, always keeping it updated and available at",
      link: "https://primi.com.br/privacidade",
    },
    copyright: "© {year} Primi Tecnologia Ltda. All rights reserved.",
  },
  termsOfUsagePage: {
    title: "Terms and Conditions of Use",
    subtitle: "Validador Platform",
    introP1:
      "These Terms and Conditions of Use define the general rules of PORTAL S.I., made available through an electronic portal at",
    introP1End: ", between the following parties:",
    introP2:
      "Primi Tecnologia Ltda. (PRIMI), headquartered at Estrada Rosa Scarpa, nº 65, Votuparim, Santana de Parnaíba, São Paulo – SP, ZIP Code 06513-010.",
    introP3:
      "And, on the other side, the individual or legal entity identified in the PORTAL S.I. registration, hereinafter referred to as USER. Reading and accepting this document implies acceptance of these Terms and Conditions of Use of PORTAL S.I.",
    introP4:
      "If you do not agree with any provision of these Terms, please do not use our services. These Terms do not apply to third-party websites and/or services and products provided by third parties, even if they are connected to PORTAL S.I., advertised or disclosed on PORTAL S.I., or accessed in any way through PORTAL S.I.",
    introP5:
      "PORTAL S.I. reserves the right to change these Terms and Conditions of Use at any time, to adequately reflect updated services, policies, and practices.",
    section1: {
      title: "I. SERVICES AND GENERAL PROVISIONS",
      p1: "PORTAL S.I. is a free platform designed to search for information and processes regarding the originality, origin, and adequacy of printed materials and security devices, according to the criteria established in these Terms.",
      p2: "PORTAL S.I.'s purpose is exclusively to inform and guide citizens in a simple, easy, and transparent manner about the adequacy of security seals.",
      p3: "The USER declares and acknowledges that any query made on PORTAL S.I. will be carried out considering exclusively the databases produced by it, and PORTAL S.I. shall not be held responsible for erroneous results arising from incomplete information, incorrect information, procedural errors, or failures in the USER's equipment.",
      p4: "In this sense, PORTAL S.I. does not guarantee, under any circumstances, that any query will determine whether the consulted seal is original or fake, it always being the USER's obligation to verify the information contained in the seal, request a physical analysis of the seal from PORTAL S.I., or seek guidance from supervisory authorities.",
      p5: "New types of questions and activities may be included at any time, considering the need, relevance, pertinence, and availability of such information.",
    },
    section2: {
      title: "II. DEFINITIONS",
      p1: "The definitions are contained in PRIMI's Privacy Policy.",
    },
    section3: {
      title: "III. INTELLECTUAL PROPERTY",
      p1: "All content, materials, and services found on PORTAL S.I. (texts, images, audio, technology, logos, slogans, trademarks, advertising expressions, domains, trade names, intellectual works), as well as the software that enables the activities, are the exclusive property of PRIMI, which holds all copyrights, licenses, and intellectual property, trademark, or patent rights related thereto. Any violation of intellectual property rights by the USER shall result in their direct and personal liability for the acts committed, under the terms of the law and with the application of applicable civil and criminal sanctions.",
      p2: "The USER undertakes not to reproduce, duplicate, copy, or exploit the services provided, software used, and/or materials made available by PRIMI for any purposes not expressly authorized in this term, without its written authorization. The use of reverse engineering by the USER is also prohibited.",
    },
    section4: {
      title: "IV. TERM, TERMINATION, AND MODIFICATION OF CLAUSES",
      p1: "These Terms shall remain in effect for an indefinite period or for as long as PORTAL S.I. is available. PORTAL S.I., however, reserves the right to, at any time, without any charge or prior notice, cease its activities or limit the use of its services.",
      p2: "PORTAL S.I. reserves the right to block the USER's access and immediately terminate these Terms, without prior notice, whenever, at its sole discretion, it finds evidence of fraudulent or illegal use of PORTAL S.I. by the USER. This includes, among others, any indications - at PORTAL S.I.'s sole and subjective discretion - that the USER has defrauded or infringed the security system.",
    },
    section5: {
      title: "V. ABSENCE OF LIABILITY OF PORTAL S.I.",
      p1: "The USER acknowledges and agrees that, although PORTAL S.I. does its best to provide the most accurate research on fire extinguisher safety seals, it cannot guarantee the accuracy, effectiveness, or adequacy of any information provided.",
      p2: "The USER must assume full responsibility and accept all risks inherent in the use of PORTAL S.I. Any information related to or available on PORTAL S.I., including the results of searches carried out, are presented on the trust and condition that the USER has provided and fulfilled all steps faithfully, and they were not created to meet specific needs, nor to guide the USER on compliance with current legislation, or to negatively influence the purchase process or choice of any specific supplier, and may include technical, legal, regulatory inaccuracies or typographical errors.",
      p3: "PORTAL S.I. reserves the right to add, remove, or modify its features and scopes, in whole or in part, at any time, without prior notice.",
      p4: "PORTAL S.I. will make its best efforts to remain accessible constantly, uninterruptedly, and free from any errors; however, PORTAL S.I. shall not be liable for damages arising from failure or interruption in the provision of available services.",
      p5: "PORTAL S.I. offers no warranties of any kind regarding the queries made. In this sense, the USER declares to be aware and agrees that PORTAL S.I. disclaims any liability for any implied warranties or warranties not expressly provided herein, including, without limitation, any warranties of fitness for a particular purpose.",
      p6: "PORTAL S.I. is not responsible and offers no guarantee of the accuracy, effectiveness, timeliness, or adequacy of any information, content, product, or service provided by third parties, including hyperlinks to third-party pages.",
      p7: "PORTAL S.I. does not guarantee that it will be free from errors and/or that it will be available 24 (twenty-four) hours a day, 7 (seven) days a week. PORTAL S.I. reserves the right to become unavailable for the period necessary for maintenance and/or implementation of improvements.",
      p8: "PORTAL S.I. shall not, under any circumstances, be held liable for indirect damages, lost profits, or data loss related to its use.",
    },
    section6: {
      title: "VI. GENERAL CONDITIONS",
      p1: "By using PORTAL S.I., the USER expressly accepts all clauses of this instrument, as well as the activities that exist and may exist, recognizing them as innocent, healthy, good-faith, and non-offensive, accepting its rules, instructions, and conditions contained in the website itself, in an absolute and unrestricted manner, warranting that they will not feel in any way outraged, offended, or harmed by them.",
      p2: "Should PORTAL S.I. create an activity that the USER in any way does not consider innocent, healthy, good-faith, or non-offensive, or that may eventually offend or harm them, the USER is obliged to cease using the services.",
      p3: "Any judicial or extrajudicial claim that may be filed against PORTAL S.I. due to breach or infringement of any clause or provision of this instrument shall oblige the USER to respond fully and, if applicable, in recourse, for all losses and damages caused to PORTAL S.I. and/or third parties.",
      p4: "The services and content available on third-party websites are the sole and exclusive responsibility of the third party. You acknowledge and agree that PORTAL S.I. does not guarantee, endorse, assume, or have any responsibility for third-party products, services, or websites.",
      p5: "PORTAL S.I. makes available to the USER a channel for clarifying doubts, suggestions, and complaints regarding the services provided, through contact channels made available in PRIMI's Privacy Policy.",
    },
    section7: {
      title: "VII. PRIVACY, SECURITY, COOKIES, AND DATA PROCESSING",
      p1: "All items related to Privacy, Security, Cookies, and Data Processing are addressed in PRIMI's Privacy Policy.",
    },
    section8: {
      title: "VIII. APPLICABLE LAW AND JURISDICTION",
      p1: "These conditions are governed solely and exclusively by the laws of the Federative Republic of Brazil, and any legal dispute arising from their interpretation or application shall be judged by Brazilian courts, with the jurisdiction of the Capital of the State of São Paulo being elected, however privileged another may be or may become.",
    },
    copyright: "© {year} Primi Tecnologia Ltda. All rights reserved.",
  },
  cookieConsentBanner: {
    description:
      "We use cookies to help you navigate our website and improve our services. By continuing to browse, you agree to our Terms of Use and our",
    privacyLink: "Privacy Policy.",
    descriptionSuffix: "",
    acceptAll: "Accept all cookies",
    rejectNonEssential: "Reject non-essential cookies",
  },
};
